module.exports = __webpack_public_path__ + "img/140003.dca172aa.png";